<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4 v-if="!data">
                    REGISTER CREDIT CARD
                </h4>
                <h4 v-else>
                    UNREGISTER CREDIT CARD
                </h4>
            </div>
        </div>
        <b-alert
            show
            variant="primary"
        >
            <div class="alert-body">
                <ul style="list-style:circle;margin-top:20px;">
                    <li>
                        신용카드를 등록하여 정기빌링을 활성화하시면 매달 결제하시는 불편함없이 정기적으로 과금되게 됩니다.
                    </li>
                    <li>
                        카드관련 결제정보는 PG사 (주)케이지올앳에서 암호화하여 관리합니다. (케이지올앳 정기결제)
                    </li>
                    <li>
                        {{ COMPANY_TITLE }} 는 고객님의 카드번호 대신 암호화된 코드만 저장합니다.
                    </li>
                    <li>
                        카드를 등록하신 후 정기빌링을 더이상 원하지 않으시면 이곳에서 취소하실 수 있습니다.
                    </li>
                </ul>
            </div>
        </b-alert>
        <div v-if="!data" style="text-align:center;margin:20px;">
            <div style="margin-bottom:20px;">
                <p>
                    <b>정기빌링이 활성화되지 않았습니다.</b>
                </p>
                <p v-if="hasWritePermission(project)">
                    <b>활성화하시려면 다음 버튼을 클릭하여 진행해주세요.</b>
                </p>
            </div>
            <div v-if="hasWritePermission(project)">
                <b-button variant="success" @click="enableRegularBilling">
                    <feather-icon icon="CreditCardIcon"/>
                    Register regular billing
                </b-button>
            </div>
            <form ref="FormEnableRegularBilling" id="FormEnableRegularBilling" method="POST" target="hiddenFrame">
                <input type="hidden" name="allat_encode_type" :value="ALLAT_ENCODE_TYPE">
                <input type="hidden" name="allat_shop_id" :value="ALLAT_SHOP_ID">
                <input type="hidden" name="allat_order_no" :value="allatOrderNo">
                <input type="hidden" name="shop_receive_url" :value="enableReceiveUrl">
                <input type="hidden" name="allat_enc_data">
                <input type="hidden" name="allat_product_nm" :value="ALLAT_PRODUCT_NM">
                <input type="hidden" name="allat_email_addr" :value="email">
                <input type="hidden" name="allat_fix_type" :value="ALLAT_FIX_TYPE">
                <input type="hidden" name="allat_test_yn" :value="ALLAT_TEST_YN">
            </form>
        </div>
        <div v-else style="text-align:center;margin:20px;">
            <div style="margin-bottom:20px;">
                <p>
                    <b>정기빌링이 활성화되어 있습니다.</b>
                </p>
                <p>
                    <b>취소하시려면 다음 버튼을 클릭해주세요</b>
                </p>
            </div>
            <div>
                <b-button variant="warning" @click="disableRegularBilling">
                    <feather-icon icon="CreditCardIcon"/>
                    Cancel regular billing
                </b-button>
            </div>
            <form ref="formDisableRegularBilling" id="formDisableRegularBilling" method="POST" target="hiddenFrame">
                <input type="hidden" name="allat_shop_id" :value="ALLAT_SHOP_ID">
                <input type="hidden" name="allat_fix_key" :value="data">
                <input type="hidden" name="shop_receive_url" :value="disableReceiveUrl">
                <input type="hidden" name="allat_enc_data">
                <input type="hidden" name="allat_opt_pin" :value="ALLAT_OPT_PIN">
                <input type="hidden" name="allat_opt_mod" :value="ALLAT_OPT_MOD">
                <input type="hidden" name="allat_fix_type" :value="ALLAT_FIX_TYPE">
                <input type="hidden" name="allat_test_yn" :value="ALLAT_TEST_YN">
            </form>
        </div>
        <div style="margin-bottom:40px;margin-top:20px;" v-if="loading" class="loader-dots"></div>
        <iframe style="left:0px; top:0px; width:0px; height:0px; position:absolute; z-index:1000; display:block; background-color:white;" id="hiddenFrame" name="hiddenFrame" frameborder="0"></iframe>
    </b-card>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent'
export default {
    props: {
        data: {
            type: String
        },
        project: {
            type: Object,
            default: function () {
                return {
                    permissions: [],
                    usageAccountId: ''
                }
            }
        },
        user: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data () {
        return {
            loading: false,
            usageAccountId: '',
            COMPANY_TITLE: process.env.VUE_APP_CARDPAY_COMPANY_TITLE,
            SERVER: process.env.VUE_APP_COMMON_URL,
            NAMESPACE: process.env.VUE_APP_NAMESPACE,
            SERVICE_GROUP: process.env.VUE_APP_SERVICE,
            ALLAT_SHOP_ID: process.env.VUE_APP_CARDPAY_REGULAR_SHOP_ID,
            PATH: '/kg/regular-billing',
            ALLAT_ENCODE_TYPE: 'U',
            ALLAT_PRODUCT_NM: 'Amazon Web Services',
            ALLAT_FIX_TYPE: 'FIX',
            ALLAT_TEST_YN: 'N',
            ALLAT_OPT_PIN: 'NOVIEW',
            ALLAT_OPT_MOD: 'WEB'
        }
    },
    computed: {
        email () {
            return this.user.email
        },
        allatOrderNo () {
            return `rb${this.project.usageAccountId}`
        },
        enableReceiveUrl () {
            return `${this.SERVER}${this.PATH}/${this.NAMESPACE}/${this.SERVICE_GROUP}/${this.ALLAT_SHOP_ID}/${this.project.usageAccountId}`
        },
        disableReceiveUrl () {
            return `${this.SERVER}${this.PATH}/cancel/${this.NAMESPACE}/${this.SERVICE_GROUP}/${this.ALLAT_SHOP_ID}/${this.project.usageAccountId}`
        }
    },
    created () {
        window.receiveMessage = this.receiveMessage
    },
    mounted () {
        this.$_allatPayPlus()
    },
    destroyed () {
        window.receiveMessage = undefined
    },
    methods: {
        hasWritePermission (project) {
            return project.permissions && project.permissions.indexOf('WRITE') > -1
        },
        enableRegularBilling () {
            this.loading = true
            window.Allat_Plus_Fix(this.$refs['FormEnableRegularBilling'], '0', '0')
        },
        disableRegularBilling () {
            this.loading = true
            window.Allat_Plus_Fix_Cancel(this.$refs['formDisableRegularBilling'], '0', '0')
        },
        receiveMessage ({ replyCd, replyMsg, message }) {
            this.loading = false
            if (replyCd === '0000') {
                this.$emit('get:allatkey')
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: `${message}`,
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: `${replyMsg}`
                    }
                })
            } else {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: `${replyCd}`,
                        icon: 'CoffeeIcon',
                        variant: 'warning',
                        text: `${replyMsg}`
                    }
                })
            }
        }
    },
    watch: {
        project () {
            this.loading = false
        }
    }
}
</script>

<style>

</style>
